/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { FormEvent, KeyboardEvent } from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  className?: string;
  pattern?: string;
  name?: string;
  value: string;
  placeholder: string;
  autoFocus?: boolean;
  disabled?: boolean;
  type?: "text" | "password" | "date";
  icon?: IconProp;
  label?: string;
  onChange?: (e: FormEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: KeyboardEvent<HTMLElement>) => void;
};

export function Input({
  label,
  placeholder,
  name,
  value,
  type,
  icon,
  disabled,
  className,
  autoFocus = false,
  pattern,
  onChange,
  onKeyPress,
}: Props) {
  return (
    <>
      {label ? (
        <label className="block text-gray-500 text-sm mb-2" htmlFor="">
          {label}
        </label>
      ) : (
        <></>
      )}
      <div className="group w-full flex border border-gray-300 rounded">
        {icon ? (
          <span className="inline-block bg-gray-100 border-r border-gray-300 pt-2 px-3 text-gray-500 rounded-l">
            <FontAwesomeIcon icon={icon} />
          </span>
        ) : (
          <span />
        )}
        <input
          className={
            `w-full bg-white px-4 py-2 border-none focus:outline-none ` +
            `text-gray-800 ` +
            `${icon} ? " rounded-l-0 rounded-r " : " rounded "`
          }
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={onChange}
          pattern={pattern}
          onKeyDown={onKeyPress}
        />
      </div>
    </>
  );
}
